var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreepik2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 145,
    viewBox: "0 0 190 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Landscape--inject-1--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M175.401 100.496C175.171 98.9555 174.888 97.4291 174.566 95.9219L160.118 102.925L175.401 100.496Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M103.982 46.8932C103.982 46.8932 61.2623 63.9044 38.1695 72.1556C34.3208 78.3225 31.3984 85.0212 29.4959 92.0372L66.1775 76.01L37.1519 94.9988L58.2719 91.3076L57.7439 93.9428L114.72 78.65L32.4047 116.119L45.0671 104.508L26.8799 111.468V111.612C26.8686 120.82 28.5645 129.95 31.8815 138.54L112.603 107.676L68.2703 130.898L147.432 102.396L126.312 107.148L155.87 92.3684H139.536L169.92 81.5588C168.918 79.2868 167.811 77.0772 166.598 74.93L105.758 95.5364L162.456 68.402C155.873 59.1217 147.256 51.4688 137.264 46.0277C127.271 40.5867 116.167 37.5015 104.8 37.0078C93.4331 36.5141 82.1035 38.625 71.6769 43.1793C61.2503 47.7335 52.0025 54.6106 44.6399 63.2852L103.982 46.8932Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M155.899 131.961C154.555 131.961 166.656 125.557 175.646 120.897C176.404 114.769 176.404 108.572 175.646 102.445L99.9548 134.063L120 118.761L50.6396 144.09H168.806C171.181 139.174 173.004 134.01 174.24 128.692C167.889 129.935 157.358 131.961 155.899 131.961Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M175.401 100.496C175.171 98.9555 174.888 97.4291 174.566 95.9219L160.118 102.925L175.401 100.496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M103.982 46.8932C103.982 46.8932 61.2623 63.9044 38.1695 72.1556C34.3208 78.3225 31.3984 85.0212 29.4959 92.0372L66.1775 76.01L37.1519 94.9988L58.2719 91.3076L57.7439 93.9428L114.72 78.65L32.4047 116.119L45.0671 104.508L26.8799 111.468V111.612C26.8686 120.82 28.5645 129.95 31.8815 138.54L112.603 107.676L68.2703 130.898L147.432 102.396L126.312 107.148L155.87 92.3684H139.536L169.92 81.5588C168.918 79.2868 167.811 77.0772 166.598 74.93L105.758 95.5364L162.456 68.402C155.873 59.1217 147.256 51.4688 137.264 46.0277C127.271 40.5867 116.167 37.5015 104.8 37.0078C93.4331 36.5141 82.1035 38.625 71.6769 43.1793C61.2503 47.7335 52.0025 54.6106 44.6399 63.2852L103.982 46.8932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M155.899 131.961C154.555 131.961 166.656 125.557 175.646 120.897C176.404 114.769 176.404 108.572 175.646 102.445L99.9548 134.063L120 118.761L50.6396 144.09H168.806C171.181 139.174 173.004 134.01 174.24 128.692C167.889 129.935 157.358 131.961 155.899 131.961Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M81.6575 25.5298C88.6826 25.5298 94.3775 19.8349 94.3775 12.8098C94.3775 5.78479 88.6826 0.0898438 81.6575 0.0898438C74.6324 0.0898438 68.9375 5.78479 68.9375 12.8098C68.9375 19.8349 74.6324 25.5298 81.6575 25.5298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M184.617 144.09H189.417",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M26.6973 144.09H180.777",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M29.2178 144.091L54.797 123.091C54.9466 122.985 55.1163 122.911 55.2955 122.873C55.4748 122.835 55.6599 122.834 55.8395 122.87C56.0192 122.906 56.1897 122.978 56.3405 123.082C56.4914 123.186 56.6195 123.32 56.717 123.475C57.4802 124.617 55.9538 132.638 55.9538 132.638L60.1538 133.022L60.917 135.691L63.5906 138.364L63.9698 144.091H29.2178Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M8.21249 143.203L24.6333 131.366C24.6333 131.366 27.3069 130.987 26.9229 133.656C26.5389 136.325 22.7229 139.387 22.7229 139.387L23.1069 142.44L23.7021 144.091H4.39648L8.21249 143.203Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreepik2);
export default __webpack_public_path__ + "static/media/freepik2.440bac0f8b8091d2c9d912d9ef51913f.svg";
export { ForwardRef as ReactComponent };